/*
	Copyright (c) 2022 PierceGearhart
	StellaNode Website

	Source code shall not be distributed or modified without
	prior permission from the copyright holder (PierceGearhart) or the
	client (Cyperhost).
*/

// React useState
import { useState } from "react";
// Components
import MenuItem from '../components/menuItem';
import MenuButton from '../components/menuButton';
// Images
import Browse from '../assets/images/navigation/browse.svg';
import Discord from '../assets/images/navigation/discord.svg';
import Domain from '../assets/images/navigation/domain.svg';
import Reseller from '../assets/images/navigation/reseller.svg';
import Transfer from '../assets/images/navigation/transfer.svg';
import Website from '../assets/images/navigation/website.svg';
import About from '../assets/images/navigation/about.svg';
import Knowledgebase from '../assets/images/navigation/knowledgebase.svg';
import Partners from '../assets/images/navigation/partners.svg';
import Contact from '../assets/images/navigation/contact.svg';
import Affiliates from '../assets/images/navigation/affiliates.svg';
import Node from '../assets/images/navigation/node.svg';

const Header = () => {
    const [menuState, setMenuState] = useState(0);
    // Hosting Options
    const hostingOptions = [
        { name: 'Minecraft Hosting', icon: Browse, description: 'View our Minecraft Plans', link: '/games/minecraft', linkType: 'route' },
        { name: 'Browse all Games', icon: Browse, description: 'All Game Servers we offer', link: '/games', linkType: 'route' },
        { name: 'Domain Registration', icon: Domain, description: 'Access your Website anywhere', link: 'https://client.cyperhost.com/cart.php?a=add&domain=register', linkType: 'link' },
        { name: 'Transfer a Domain', icon: Transfer, description: 'Bring your domain to us', link: 'https://client.cyperhost.com/cart.php?a=add&domain=transfer', linkType: 'link' },
        { name: 'Discord Bot Hosting', icon: Discord, description: 'Get your Discord Bot online', link: '/hosting/discord', linkType: 'route' },
        { name: 'Reseller Hosting', icon: Reseller, description: 'Web-Hosting for your clients', link: '/hosting/reseller', linkType: 'route' },
        { name: 'Website Hosting', icon: Website, description: 'Get your Website online', link: '/hosting/web-hosting', linkType: 'route' }
    ]
    // Information Options
    const infoOptions = [
        { name: 'About Us', icon: About, description: 'Learn more about us', link: '/about', linkType: 'route' },
        { name: 'Partners', icon: Partners, description: 'Our partnerships', link: '/partners', linkType: 'route' },
        { name: 'Affiliates', icon: Affiliates, description: 'Promote & make money', link: '/affiliates', linkType: 'route' },
        { name: 'Knowledgebase', icon: Knowledgebase, description: 'General help for services', link: 'https://help.cyperhost.com/en/', linkType: 'link' },
        { name: 'Contact Us', icon: Contact, description: 'Reach out to us', link: 'https://client.cyperhost.com/submitticket.php', linkType: 'link', externalLink: true },
        { name: 'Node Stats', icon: Node, description: 'Our node statistics', link: 'https://status.cyperhost.com/', linkType: 'link' }
    ]
    // Buttons
    const buttonOptions = [
        { name: 'Login to Client Area', link: 'https://client.cyperhost.com/', linkType: 'link' },
        { name: 'Login to Cyper Panel', link: 'https://panel.cyperhost.com/', linkType: 'link' },
    ]

    return (
        <div className="mobile col-span-2 block sm:block md:block lg:hidden">
            <div className="mobile-icon cursor-pointer" onClick={() => setMenuState(1)}>
                <svg xmlns="http://www.w3.org/2000/svg" class="h-7 w-7 float-right text-gray-100" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h8m-8 6h16" />
                </svg>
            </div>
            {menuState === 1 && 
                <div className="mobile-menu absolute w-full h-max bg-transparent top-0 left-0 px-3.5 pt-6 pb-0" Style="z-index: 999!important;">
                    <div className="menu-inner bg-menu h-max rounded-md" Style="z-index: 999!important;">
                        <div className="mobile-close flex justify-end py-6 px-5">
                            <span className="cursor-pointer" onClick={() => setMenuState(0)}>
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-gray-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </span>
                        </div>
                        <div className="mobile-content h-max px-8 pb-6" Style="margin-top: -40px;">
                            <div className="nav-type mb-7">
                                <div className="header mb-7">
                                    <h1 className="text-gray-300 text-lg font-semibold mb-2">Services</h1>
                                    <hr className="border-primary w-12" />
                                </div>
                                <div className="body">
                                    {hostingOptions.map(item => <MenuItem data={item} />)}
                                </div>
                            </div>
                            <div className="nav-type mb-10">
                                <div className="header mb-7">
                                    <h1 className="text-gray-300 text-lg font-semibold mb-2">Information</h1>
                                    <hr className="border-primary w-12" />
                                </div>
                                <div className="body">
                                    {infoOptions.map(item => <MenuItem data={item} />)}
                                </div>
                            </div>
                            <div className="nav-buttons">
                                {buttonOptions.map(button => <MenuButton data={button} />)}
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}

export default Header